import { Field, ExpandableFieldMeta } from "@lib/shared/types";
import { FieldData } from "../types";

/** True when the field declares an `expandable` meta key. */
export function isExpandable(field: Field): boolean {
    const metaKeys: string[] = field.meta ? Object.keys(field.meta) : [];
    return Array.isArray(metaKeys) && metaKeys.length
        ? metaKeys[0] === "expandable"
            ? true
            : false
        : false;
}

/**
 * Returns the array of expandable Field-shaped objects for the given parent
 * field, looked up from the live `fieldsData` map.
 */
export function getExpandableFields(
    field: Field,
    fieldsData: { [k: string]: FieldData },
): Field[] {
    const filteredExpandableFields = Object.keys(
        JSON.parse(field.meta?.expandable ?? "[]") as ExpandableFieldMeta,
    ).filter((f) => f !== field.codeName);

    const allFields: string[] = Object.keys(fieldsData);
    const arrayOfExpandableFields: Field[] = [];
    allFields.forEach((codeName) => {
        if (filteredExpandableFields.includes(codeName)) {
            arrayOfExpandableFields.push(
                fieldsData[codeName] as unknown as Field,
            );
        }
    });

    return arrayOfExpandableFields;
}
